import { createFileRoute } from '@tanstack/react-router';
import { ContractPage } from '@/features/finance';

/** One contract: its terms, amendments and progress. Bond-release notifications link here. */
export const Route = createFileRoute('/_auth/o/$orgId/finance/contracts/$contractId/')({
  component: ContractRoute,
});

function ContractRoute() {
  const { orgId, contractId } = Route.useParams();
  return <ContractPage orgId={orgId} contractId={contractId} />;
}
